import React, { useEffect, useState } from "react";
import Button from "../button";
import "./index.scss";

const TitleScreen = ({ hide, onClick, text, config }) => {
  const [options, setOptions] = useState({});

  useEffect(() => {
    setOptions({});
  }, [hide]);

  const handleClick = () => {
    if (onClick) onClick(options);
  };

  const handleSetOptions = (event, category, selection) => {
    event.stopPropagation();

    if (options[category] === selection) return;

    setOptions({ ...options, [category]: selection });
  };

  return (
    <div className={`title-screen${hide ? " hide" : ""}`}>
      {Object.keys(config).map((x, index) => (
        <div className="category" key={`${x}_${index}`}>
          <div className="category-title">{x}</div>
          {Object.keys(config[x]).map((y) => (
            <div
              key={`${y}_${index}`}
              className={`category-option${options[x] === y ? " active" : ""}`}
              onClick={(e) => handleSetOptions(e, x, y)}
            >
              <p>{y}</p>
            </div>
          ))}
        </div>
      ))}
      <Button onClick={handleClick} text="generate" larger darker />
    </div>
  );
};

export default TitleScreen;
